<template>
	<div class="app-countdown">
		<slot :props="{ time: formattedTimeRemaaining }">
			{{ formattedTimeRemaaining }}
		</slot>
	</div>
</template>

<script>
export default {
	props: {
		startTime: String,
		endTime: String,
		currentTime: String
	},

	async mounted () {
		this.$nextTick()
		this.getRemainingTime()
	},

	data () {
		return {
			timeRemaining: null,
			duration: 0,
			interval: null
		}
	},

	computed: {
		formattedTimeRemaaining () {
			if (!this.timeRemaining || this.timeRemaining < 0) return '00:00:00'
			if (this.timeRemaining > this.duration) return '--:--:--'
			const total = this.timeRemaining
			const seconds = String(Math.floor((total / 1000) % 60)).padStart(2, 0)
			const minutes = String(Math.floor((total / 1000 / 60) % 60)).padStart(2, 0)
			const hours = String(Math.floor((total / (1000 * 60 * 60)))).padStart(2, 0)
			// const hours = String(Math.floor((total / (1000 * 60 * 60)) % 24)).padStart(2, 0)
			// const days = Math.floor(total / (1000 * 60 * 60 * 24))
			// if (days) return `${days} ${days > 1 ? 'days' : 'day'} ${hours}:${minutes}:${seconds}`
			return `${hours}:${minutes}:${seconds}`
		}
	},

	watch: {
		startTime () {
			// incase session was updated
			this.getRemainingTime()
		},

		endTime () {
			// incase session was updated
			this.getRemainingTime()
		}
	},

	methods: {
		getRemainingTime () {
			if (!this.startTime || !this.endTime) return

			const start = new Date(this.startTime).getTime()
			const end = new Date(this.endTime).getTime()
			const current = this.currentTime ? new Date(this.currentTime).getTime() : Date.now()

			if (end <= current) return

			this.duration = end - start

			let remaining = end - current
			this.timeRemaining = remaining

			if (this.interval) clearInterval(this.interval)
			this.interval = setInterval(() => {
				this.timeRemaining -= 1000
				if (this.timeRemaining <= 0) {
					clearInterval(this.interval)
					this.timeRemaining = null
				}
			}, 1000)
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/app-components/AppCountdown.vue